import moment from 'moment';
export default {
  install(Vue) {
    /**
     * 获取区域/时间查询条件
     * @param {String} areaType   行政级别(必填) 0:全国；1:省；2：市；3：县；4：实体
     * @param {String} areaCode   行政编码 110100
     * @param {String} timeType   时间类型(必填) hour/day/month/year
     * @param {String} timeValue  时间值  0:当日/当月/当年
     */
    Vue.prototype.getAreaTimeSearchParams = function (areaType, areaCode, startTime, endTime) {
      var params = {
        polityType: areaType,
      }

      if (areaType == 1) {
        params.province = areaCode;
        params.provinceCode = areaCode;
      } else if (areaType == 2) {
        params.city = areaCode;
        params.cityCode = areaCode;
      } else if (areaType == 3) {
        params.district = areaCode;
        params.districtCode = areaCode;
      } else if (areaType == 4) {
        params.entity = areaCode;
        params.entityCode = areaCode;
      }

      if (startTime && endTime) {
        params.startTime = startTime;
        params.endTime = endTime;
        let days = moment(endTime).diff(moment(startTime),'days')
        if(days == 0){
          params.timeType = 'hour'
          params.timeValue = '24'
        }else if(days <= 30){
          params.timeType = 'day'
          params.timeValue = days
        }else{
          params.timeType = 'month'
          params.timeValue =  moment(endTime).diff(moment(startTime),'month')
        }
      }
      return params;
    }

    /**
     * 获取图列名称
     */
    Vue.prototype.getTimeRangLegend= function (startTime, endTime){
      let year = moment(startTime).year()
      let year2 = moment(endTime).year()
      if(year == year2){
        return year
      }else{
        return year + "-" + year2
      }
    }

    /**
     * 格式化时间
     */
    Vue.prototype.getTimeByType= function (type,date){
      if(type == 'hour'){
        return moment(date).get('hour') + '时'
      }else if(type == 'day'){
        return moment(date).format('MM.DD')
        // return moment(date).get('date') + '日'
      }else{
        return (moment(date).get('month') + 1) + '月'
      }
    }
    
    // 今日/本月/本年
    Vue.prototype.getAreaTimeSearchParams3 = function (areaType, areaCode, timeType, timeArr) {
      var params = {
        polityType: areaType,
        timeType: timeType,
      }
  
      if (areaType == 1) {
        params.province = areaCode;
        params.provinceCode = areaCode;
      } else if (areaType == 2) {
        params.city = areaCode;
        params.cityCode = areaCode;
      } else if (areaType == 3) {
        params.district = areaCode;
        params.districtCode = areaCode;
      } else if (areaType == 4) {
        params.entity = areaCode;
        params.entityCode = areaCode;
      }
      if(timeType){
        if (timeType == 'hour') {
          //今日  返回今日
          params.startTime = moment(new Date()).format("YYYY-MM-DD");
          params.endTime = moment(new Date()).format("YYYY-MM-DD");
          params.timeValue = moment(new Date()).get('hour');
        } else if (timeType == 'day') {
          var oDate = new Date();
          params.startTime = moment(new Date(oDate.getFullYear(), oDate.getMonth(), 1)).format("YYYY-MM-DD");
          params.endTime = moment(new Date()).endOf('month').format('YYYY-MM-DD');
          params.timeValue = moment(new Date()).get('date');
        } else if (timeType == 'month') {
          var curDate = new Date();
          var year = curDate.getFullYear();
          params.startTime = year + "-01-01";
          params.endTime =moment(new Date()).format("YYYY-MM-DD");
          params.timeValue =moment(new Date()).get('month') + 1;
        }
      }else if(timeArr){
        params.startTime = moment(timeArr[0]).format("YYYY-MM-DD");
          params.endTime = moment(timeArr[1]).format("YYYY-MM-DD");
          let days = moment(params.endTime).diff(params.startTime, 'days')
          let months = moment(params.endTime).diff(params.startTime, 'months')
          let num =  moment(params.startTime).endOf('month').format("DD")
          if(days == 0){
            timeType = 'hour'
          }else if(days < Number(num)){
            timeType = 'day'
          }else{
            timeType = 'month'
          }
          params.timeType = timeType
          if(timeType == 'hour'){
            params.timeValue = moment(timeArr[1]).diff(timeArr[0], 'hours')
          }else if(timeType == 'day'){
            params.timeValue = days
          }else if(timeType == 'month'){
            params.timeValue = months
          }
        }
  
      return params;
    }

      /**
     * 时间字符串格式化
     */
      Vue.prototype.timeFormatself = function (timeStr, type) {
        if (type == 'hour') {
          // console.log(timeStr.substr(11,2))
          return timeStr.substr(11, 2) + "时";
        } else if (type == 'day') {
          // console.log(timeStr.substr(5,5).replace('-','.'))
          return timeStr.substr(5, 5).replace('-', '.');
        } else if (type == 'month') {
          // console.log(timeStr.substr(5,2)+'月')
          return timeStr.substr(5, 2) + '月';
        } else if (type == 'year') {
          console.log(timeStr + '年');
          return timeStr + '年';
        } else if (type == 'week') {
          // console.log(timeStr+'年');
          return timeStr.substr(5, 5).replace('-', '.');
        }
      }
  }

}
